<template>
    <footer class="footer bg-white mt-3" id="footer">
        <div class="container shadow">
            <div class="row align-items-center justify-content-md-between p-2">
                <div class="img-block text-center">
                    <img class="w-75" src="../assets/images/bekam/brand-rabbani.png" alt="Brand Rabbani">
                </div>
            </div>
            <div class="row align-items-center justify-content-center bg-secondary p-2">
                <div class="text-center">
                    <span class="text-white fs-16 fw-bold ls-05">©<i class="ml-1">{{ 'Rabbani '+new Date().getFullYear() }}</i></span>
                </div>
            </div>
        </div>

        </footer>
</template>

<script>
export default {
    methods: {
        
    },
}
</script>